import { useState } from 'react';

export default function ExpandableText({ children, lines = 3 }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="expandable-wrap">
      <p
        className={`expandable-text ${expanded ? '' : 'is-clamped'}`}
        style={{ '--line-clamp': lines }}
      >
        {children}
      </p>
      <button
        type="button"
        className="text-btn expandable-btn"
        onClick={() => setExpanded((v) => !v)}
      >
        {expanded ? '閉じる' : '続きを読む'}
      </button>
    </div>
  );
}
